import { fetcher } from '../utils'

export default async (): Promise<boolean> => fetcher(`/api/appreview`, 'GET', undefined)
